import formapimodalpatientsipdview from "./ipdpatientsviews";

export default function formapimodalpatientsipdPagination({
    data,
    pageno,
    pagesize,
    count
  })
  {
  return Object.freeze({
    
    data:data !== null ? formapimodalpatientsipdview(data) : [],
    pageno,
    pagesize,
    count,
  });
  }